/**
 * Transform brand
 * @param {Array} input brand
 * @returns {Array} brand
 */
export const transformBrand = (input = {}) => {
	return {
		id: input.id || null,
		name: input.name || null,
		slug: input.slug || null,
	};
};

/**
 * Transform brands
 * @param {Array} input brands
 * @returns {Array} brands
 */
export const transformBrands = (input = []) => {
	return input.map((item) => transformBrand(item));
};